// src/components/LogoutButton.js
import React from 'react';
import Button from './Button';
import api from '../../Api';
import iconLogout from '../../assets/icon/general/logout.png'
const LogoutButton = () => {
  const handleLogout = async () => {
    try {
      await api.post('/user/logout');
      localStorage.removeItem('token');
      // Reindirizza l'utente alla pagina di login o a dove preferisci
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout fallito:', error);
      // Qui puoi gestire eventuali errori, per esempio mostrando un messaggio all'utente
    }
  };

  return <Button onClick={handleLogout}><img src={iconLogout} alt="Logout" className='w-6 h-6' /></Button>;
};

export default LogoutButton;
